import { post } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

import {
  baseCsvUrl,
  emailEntityBaseCsvUrl,
  investigationPocBaseCsvUrl,
} from 'containers/Investigation/ThreatLog/constants'

export default () => ({
  shareLogsCSV(filters, body) {
    const { emailDateRange, logDateRange } = filters
    const changedFilters = {
      ...filters,
      page_size: 10000,
      page_number: 1,
    }
    return post(
      buildURL(baseCsvUrl, { ...changedFilters, ...body, shareCSV: true }),
      {
        emailDateRange,
        logDateRange,
      },
      {
        'Content-Type': 'application/json',
      }
    )
  },
  shareInvestigationCSV(filters, body) {
    const { emailDateRange, logDateRange } = filters
    const changedFilters = {
      ...filters,
      page_size: 10000,
      page_number: 1,
    }
    return post(
      buildURL(emailEntityBaseCsvUrl, { ...changedFilters, ...body, shareCSV: true }),
      {
        emailDateRange,
        logDateRange,
        tagIds: filters.tagIds,
      },
      {
        'Content-Type': 'application/json',
      }
    )
  },
  shareInvestigationPocCSV(filters, body) {
    const { emailDateRange, logDateRange } = filters
    const changedFilters = {
      ...filters,
      page_size: 200000,
      page_number: 1,
    }
    return post(
      buildURL(investigationPocBaseCsvUrl, { ...changedFilters, ...body, shareCSV: true }),
      {
        emailDateRange,
        logDateRange,
        tagIds: filters.tagIds,
      },
      {
        'Content-Type': 'application/json',
      }
    )
  },
  createIncident(companyId = '', eid, body) {
    return post(
      `/members-api/irontraps/incident/${eid}/escalate?companyFilter=${companyId}`,
      body,
      {
        'Content-Type': 'application/json',
      }
    )
  },
  releaseFromSpam(body) {
    return post(`/members-api/search/entity_investigation/bulk_email_release/`, body)
  },
})
